import React from 'react';
import { connect } from 'react-redux';
import { getTenantState } from '../../store/selectors';
import {
  getHighestLevelOfEducationCounts,
  getHighestLevelOfEducationCountsCsv,
} from '../../store/actions';
import { reportingCopy } from '../../copy/advisor-dashboard/advisor-dashboard-base.json';
import Loading from '../utility/Loading';
import HighestLevelOfEducationChart from './highest-level-of-education-components/HighestLevelOfEducationChart';
import CSVDownloadMenu from './reporting-components/CSVDownloadMenu';

export class HighestLevelOfEducation extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      data: {},
    };

    this.getData = this.getData.bind(this);
    this.getCsv = this.getCsv.bind(this);
  }

  async componentDidMount() {
    this.setState({ data: await this.getData(), loading: false });
  }

  async getData() {
    const data = await this.props.getHighestLevelOfEducationCounts(
      this.props.tenant.id
    );
    return data;
  }

  async getCsv() {
    const csvData = await this.props.getHighestLevelOfEducationCountsCsv(
      this.props.tenant.id
    );
    return csvData;
  }

  render() {
    return (
      <div
        className="highest-level-of-education"
        id="highest-level-of-education"
      >
        <div className="highest-level-of-education__header">
          <div className="highest-level-of-education__heading">
            {reportingCopy.highestLevelOfEducation.heading}
          </div>
          <div className="highest-level-of-education__meatball-menu-container">
            <CSVDownloadMenu
              csv={this.getCsv}
              filename="highest-level-of-education"
            />
          </div>
        </div>
        <div className="highest-level-of-education__subheading">
          {reportingCopy.highestLevelOfEducation.subheading}
        </div>
        {this.state.loading ? (
          <Loading height="100%" />
        ) : (
          <HighestLevelOfEducationChart data={this.state.data} />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps, {
  getHighestLevelOfEducationCounts,
  getHighestLevelOfEducationCountsCsv,
})(HighestLevelOfEducation);
